import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { BarChart, Tooltip, LineChart, CartesianGrid, Legend, Line, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts'
import { roles } from '../../../common/config'
import { createSampleTests } from '../../../common/tests/actions'
import { loadStats, clearStats, loadSubscribers } from '../../../common/users/actions'
import { Button } from '../../components'


class AdminPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      visibleUsersList: false,
      visibleTestsList: false,
      visibleHomeworkList: false,
    }
  }

  componentDidMount() {
    const { viewer, loadStats, loadSubscribers } = this.props

    if (viewer.role === roles.ADMIN) {
      loadStats()
      loadSubscribers()
    }
  }

  componentWillUnmount() {
    this.props.clearStats()
  }

  render() {
    const { stats, viewer, createSampleTests, subscribers } = this.props
    const { visibleUsersList, visibleTestsList, visibleHomeworkList } = this.state
    
    if (!stats || viewer.role !== roles.ADMIN) {
      return null
    }

    const materialsStats = Object.keys(stats.lessonsByDays).map(key => ({
      day: key,
      lessons: stats.lessonsByDays[key],
      tests: stats.testsByDays[key],
      homeworks: stats.homeworksByDays[key],
    }))

    const resultsStats = Object.keys(stats.resultsByDays).map(key => ({
      day: key,
      results: stats.resultsByDays[key],
    }))

    const teachersStats = Object.keys(stats.loggedInByDays).map(key => ({
      day: key,
      loggedIn: stats.loggedInByDays[key][roles.TEACHER],
      signedUp: stats.registeredInByDays[key][roles.TEACHER],
    }))

    const usersStats = Object.keys(stats.loggedInByDays).map(key => ({
      day: key,
      loggedIn: stats.loggedInByDays[key][roles.USER],
      signedUp: stats.registeredInByDays[key][roles.USER],
    }))

    return (
      <div className="stats-page">
        <h2>Štatistiky</h2>
        <div>
          <p>Subscribers: {subscribers.length}</p>
          {/*
            subscribers.map(subscriber => (
              <p key={subscriber._id}>
                <h4>{subscriber.email}</h4>
              </p>
            ))
          */}
        </div>
        <h3>Štatistiky prihlásení:</h3>
        <div className="item-box all-stats">
          <div className="row">
            <p>
              Počet studentov, ktorí sa prihlásili:
            </p>
            <p>
              {stats.allUsersStats.loggedInUsersCount[roles.USER]}
            </p>
            <p>
              Celkovy pocet prihlasení studentov:
            </p>
            <p>
              {stats.allUsersStats.totalLoggins[roles.USER]}
            </p>
          </div>
          <div className="row">
            <p>
              Počet ucitelov, ktorí sa prihlásili:
            </p>
            <p>
              {stats.allUsersStats.loggedInUsersCount[roles.TEACHER]}
            </p>
            <p>
              Celkovy pocet prihlasení ucitelov:
            </p>
            <p>
              {stats.allUsersStats.totalLoggins[roles.TEACHER]}
            </p>
          </div>
        </div>
        <h3>Prihlaseni viac ako:</h3>
        <div className="item-box all-stats">
          {
            Object.keys(stats.allUsersStats.moreThanLogins).map(key => (
              <div className="row">
                <p>{key}:</p>
                <p>{stats.allUsersStats.moreThanLogins[key][roles.USER]} študentov</p>
                <p>{stats.allUsersStats.moreThanLogins[key][roles.TEACHER]} učitelov</p>
              </div>
            ))
          }
        </div>
        <h3>Aktivita užívatelov - vytváranie materialov:</h3>
        <div className="item-box all-stats">
          <div className="row">
            <p>
              Počet studentov, ktori vyplnili test:
            </p>
            <p>
              {stats.allUsersStats.countStudentsFilledTest}
            </p>
            <p>
              Počet studentov, ktori vyplnili ulohu:
            </p>
            <p>
              {stats.allUsersStats.countStudentsFilledHomework}
            </p>
          </div>
          <div className="row">
            <p>
              Počet učitelov, ktori vytvorili test:
            </p>
            <p>
              {stats.allUsersStats.countTeachersCreatedTest}
            </p>
            <p>
              Počet učitelov, ktori vytvorili ulohu:
            </p>
            <p>
              {stats.allUsersStats.countTeachersCreatedHomework}
            </p>
          </div>
        </div>
        <h3>Vytvorených cvičení viac ako:</h3>
        <div className="item-box all-stats">
          {
            Object.keys(stats.allUsersStats.moreThanLessonsCreated).map(key => (
              <div className="row">
                <p>{key}:</p>
                <p>{stats.allUsersStats.moreThanLessonsCreated[key]} učitelov</p>
              </div>
            ))
          }
        </div>
        <h3>Vytvorených testov viac ako:</h3>
        <div className="item-box all-stats">
          {
            Object.keys(stats.allUsersStats.moreThanTestsCreated).map(key => (
              <div className="row">
                <p>{key}:</p>
                <p>{stats.allUsersStats.moreThanTestsCreated[key]} učitelov</p>
              </div>
            ))
          }
        </div>
        <h3>Vytvorených úloh viac ako:</h3>
        <div className="item-box all-stats">
          {
            Object.keys(stats.allUsersStats.moreThanHomeworkCreated).map(key => (
              <div className="row">
                <p>{key}:</p>
                <p>{stats.allUsersStats.moreThanHomeworkCreated[key]} učitelov</p>
              </div>
            ))
          }
        </div>
        <div className="item-box">
          <h3>Počet užívatelov: {stats.users.length}</h3>
          <h3>Počet študentov: {stats.usersCount.students}</h3>
          <h3>Počet učitelov: {stats.usersCount.teachers}</h3>
          <h3>Počet žiakov na učitela: {stats.allUsersStats.studentsTeachersRatio}</h3>
          <Button onClick={() => this.setState({ visibleUsersList: !visibleUsersList})}>
            {
              visibleUsersList ?
                'Skryť zoznam'
              :
                'Zobraziť zoznam'
            }
          </Button>
        </div>
        {
          visibleUsersList &&
          <div>
            {
              stats.users.map(u => (
                <div key={u._id} className="item-box user-item">
                  <Link to={`/app/user/${u._id}`}>{u.name} - {u.email} {u.role === roles.TEACHER ? '- teacher' : ''}</Link>
                  <div className="float-right">
                    <p style={{ margin: 0 }}>
                      Počet prihlásení: {u.loggedInDates.length}<br />
                      Počet testov: {u.tests ? u.tests.length : 0}
                    </p>
                  </div>
                </div>
              ))
            }
          </div>
        }
        <h3>Prihlásenia a registrácie žiakov za posledný týždeň:</h3>
        <div className="item-box stats-chart">
          <ResponsiveContainer height={200} width="100%">
            <LineChart data={usersStats}>
              <Legend verticalAlign="top" height={36} />
              <XAxis dataKey="day" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Line name="Prihlásenia" type="monotone" dataKey="loggedIn" stroke="#8884d8" />
              <Line name="Registrácie" type="monotone" dataKey="signedUp" stroke="#82ca9d" />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <h3>Prihlásenia a registrácie učiteľov za posledný týždeň:</h3>
        <div className="item-box stats-chart">
          <ResponsiveContainer height={200} width="100%">
            <LineChart data={teachersStats}>
              <Legend verticalAlign="top" height={36} />
              <XAxis dataKey="day" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Line name="Prihlásenia" type="monotone" dataKey="loggedIn" stroke="#8884d8" />
              <Line name="Registrácie" type="monotone" dataKey="signedUp" stroke="#82ca9d" />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <h3>Vytvorené materiály:</h3>
        <div className="item-box stats-chart">
          <ResponsiveContainer height={200} width="100%">
            <LineChart data={materialsStats}>
              <Legend verticalAlign="top" height={36} />
              <XAxis dataKey="day" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Line name="Cvičenia" type="monotone" dataKey="lessons" stroke="#8884d8" />
              <Line name="Testy" type="monotone" dataKey="tests" stroke="#82ca9d" />
              <Line name="Domáce úlohy" type="monotone" dataKey="homeworks" stroke="#ff7300" />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <h3>Odpovede žiakov:</h3>
        <div className="item-box stats-chart">
          <ResponsiveContainer height={200} width="100%">
            <LineChart data={resultsStats}>
              <Legend verticalAlign="top" height={36} />
              <XAxis dataKey="day" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Line name="Odpovede" type="monotone" dataKey="results" stroke="#8884d8" />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </div>
        {/***** TESTS STATS ******/}
        <h3>Štatistiky - testy:</h3>
        <div className="item-box all-stats">
          <div className="row">
            <p>Celkový počet testov: {stats.allTestsStats.allCount}</p>
            <p>Vyplnených testov: {stats.allTestsStats.filledCount}</p>
            <p>Podiel vyplnených testov: {stats.allTestsStats.shareFilled} %</p>
          </div>
          <div className="row">
            <p>Počet odpovedí na jeden test: {stats.allTestsStats.answersPerItem}</p>
            <p>Celkovy počet odpovedí na test: {stats.allTestsStats.filledSumCount}</p>
          </div>
          <Button onClick={() => this.setState({ visibleTestsList: !visibleTestsList})}>
            {
              visibleTestsList ?
                'Skryť zoznam'
              :
                'Zobraziť zoznam'
            }
          </Button>
        </div>
        {
          visibleTestsList &&
          <div>
            {
              stats.allTests.map(t => (
                <div key={t._id} className="item-box user-item">
                  <Link to={`/app/test/${t._id}`}>{t.name}</Link>
                  <div className="float-right">
                    <p style={{ margin: 0 }}>
                      Počet vyplnení: {t.answersCount}
                    </p>
                  </div>
                </div>
              ))
            }
          </div>
        }
        {/***** HOMEWORK STATS ******/}
        <h3>Štatistiky - domace ulohy:</h3>
        <div className="item-box all-stats">
          <div className="row">
            <p>Celkový počet uloh: {stats.allHomeworkStats.allCount}</p>
            <p>Vyplnených uloh: {stats.allHomeworkStats.filledCount}</p>
            <p>Podiel vyplnených uloh: {stats.allHomeworkStats.shareFilled} %</p>
          </div>
          <div className="row">
            <p>Počet odpovedí na jednu ulohu: {stats.allHomeworkStats.answersPerItem}</p>
            <p>Celkovy počet odpovedí na ulohu: {stats.allHomeworkStats.filledSumCount}</p>
          </div>
          <Button onClick={() => this.setState({ visibleHomeworkList: !visibleHomeworkList})}>
            {
              visibleHomeworkList ?
                'Skryť zoznam'
              :
                'Zobraziť zoznam'
            }
          </Button>
        </div>
        {
          visibleHomeworkList &&
          <div>
            {
              stats.allHomework.map(t => (
                <div key={t._id} className="item-box user-item">
                  <Link to={`/app/homework/${t._id}`}>{t.name}</Link>
                  <div className="float-right">
                    <p style={{ margin: 0 }}>
                      Počet vyplnení: {t.answersCount}
                    </p>
                  </div>
                </div>
              ))
            }
          </div>
        }
        <h3>Celkové štatistiky:</h3>
        <div className="item-box">
          <p>Celkový počet cvičení: {stats.lessonsCount}</p>
          <p>Vyplnení testov a úloh: {stats.resultsCount}</p>
        </div>
        <h3>Admin akcie:</h3>
        <div className="admin-actions item-box float-left">
          <Button
            onClick={() => createSampleTests()}
          >
            Vytvoriť vzorové testy
          </Button>
        </div>
      </div>
    )
  }
}

AdminPage.defaultProps = {
  stats: null,
  subscribers: [],
}

AdminPage.propTypes = {
  createSampleTests: PropTypes.func.isRequired,
  loadStats: PropTypes.func.isRequired,
  loadSubscribers: PropTypes.func.isRequired,
  clearStats: PropTypes.func.isRequired,
  viewer: PropTypes.object.isRequired,
  subscribers: PropTypes.array,
  stats: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    subscribers: state.users.subscribers,
    viewer: state.users.viewer,
    stats: state.users.stats,
  }), { loadStats, clearStats, createSampleTests, loadSubscribers }),
)

export default enhance(AdminPage)



// WEBPACK FOOTER //
// ./src/browser/pages/admin/AdminPage.js